import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_VariableRelation } from '@app/hcs-shared';
export const dispatch_onVariableRelationChanged = new ThunderDispatcherV3('__onVariableRelationUpdated');
export class ModuleFE_VariableRelation_Class extends ModuleFE_BaseApi {
    constructor() {
        super(DBDef_VariableRelation, dispatch_onVariableRelationChanged);
    }
}
export const ModuleFE_VariableRelation = new ModuleFE_VariableRelation_Class();
//# sourceMappingURL=ModuleFE_VariableRelation.js.map